import { useEffect, useState } from "react";
import Button, {
  ButtonTypes,
} from "../../../../../common/components/button/button";
import Dropdown from "../../../../../common/components/inputFields/dropdown/dropdown";
import TextField from "../../../../../common/components/inputFields/textFields/textField";
import PopupLayout from "../../../../../common/components/layouts/popupLayout/popupLayout";
import { useFormRef } from "../../../../../common/customHooks/useFormRef";
import { LoadingStatus } from "../../../../../common/enums/loadingStatus";
import { NewUserModel } from "../../../models/newUserModel";
import "./editUserPopup.scss";

export default function EditUserPopup(props: {
  userData?: NewUserModel;
  dataLoadingStatus?: LoadingStatus;
  submitLoadingStatus?: LoadingStatus;
  onSubmit?: (e: NewUserModel) => void;
  onClickClose?: () => void;
}) {
  const [userData, setUserData] = useState<NewUserModel>(
    props.userData ?? ({} as NewUserModel)
  );
  const [showEditPassword, setShowEditPassword] = useState(false);
  const { validate, textFieldRef } = useFormRef();

  useEffect(() => {
    if (props.userData) setUserData(props.userData);
  }, [props.userData]);

  function loadingSkeleton() {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        {Array(4)
          .fill(null)
          .map((e, i) => (
            <div
              key={i}
              className="edit-user-skeleton"
              style={{ width: "100%", height: "30px" }}
            />
          ))}
      </div>
    );
  }

  return (
    <PopupLayout
      ttle="Add new user"
      buttonText="Add"
      onClickClose={props.onClickClose}
      onSubmit={() => props.onSubmit?.(userData)}
    >
      {props.dataLoadingStatus == LoadingStatus.LOADING ? (
        loadingSkeleton()
      ) : (
        <div className="edit-user-form">
          <div className="edit-user-row-wrap">
            <TextField
              ref={(e) => (textFieldRef.current["username"] = e)}
              validator={(e) => (e == "" ? "required" : null)}
              title="username"
              initialValue={userData.username ?? ""}
              onChange={(e) => setUserData({ ...userData, username: e })}
            />
            <TextField
              title="full name"
              initialValue={userData.fullName ?? ""}
              ref={(e) => (textFieldRef.current["full name"] = e)}
              validator={(e) => (e == "" ? "required" : null)}
              onChange={(e) => setUserData({ ...userData, fullName: e })}
            />
          </div>
          <div className="edit-user-row-wrap">
            <TextField
              title="email"
              initialValue={userData.email ?? ""}
              ref={(e) => (textFieldRef.current["email"] = e)}
              onChange={(e) => setUserData({ ...userData, email: e })}
              validator={(e) => (e == "" ? "required" : null)}
            />
            <Dropdown
              initialValue={{
                value: userData.role,
                label: userData.role ?? "",
              }}
              ref={(e) => (textFieldRef.current["role"] = e)}
              validator={(e) => (e?.value == "" ? "required" : null)}
              onChange={(e) => setUserData({ ...userData, role: e.value })}
              options={[
                {
                  value: "admin",
                  label: "Admin",
                },
                {
                  value: "contentWriter",
                  label: "Content Writer",
                },
              ]}
              title="role"
            />
          </div>
          <TextField
            disabled={!showEditPassword}
            ref={(e) => (textFieldRef.current["password"] = e)}
            validator={(e) => (e == "" && showEditPassword ? "required" : null)}
            title="password"
            captionText={!showEditPassword ? "Reset Password?" : undefined}
            isSecure
            onChange={(e) => setUserData({ ...userData, password: e })}
            onClickCaption={() => setShowEditPassword(true)}
          />
          {showEditPassword && (
            <TextField
              ref={(e) => (textFieldRef.current["confirm password"] = e)}
              validator={(e) =>
                e == ""
                  ? "required"
                  : e != undefined && e != userData.password
                  ? "password not match"
                  : null
              }
              title="confirm password"
              isSecure
              onChange={(e) => setUserData({ ...userData, confirmPassword: e })}
            />
          )}
        </div>
      )}
      <div className="create-user-buttons-container">
        <Button
          loadingStatus={props.submitLoadingStatus}
          type={ButtonTypes.PRIMARY}
          text={"Confirm"}
          onClick={async () => {
            if (await validate()) props.onSubmit?.(userData);
          }}
        />
      </div>
    </PopupLayout>
  );
}
